import React, { useState } from 'react';
import { supabase } from '../lib/supabase';
import { Button } from '../components/Button';
import { GoldFileDownloadButton } from '../components/GoldFileDownloadButton';


export function Pricing() {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');

  const handleCheckout = async (priceKey: 'CGA_STRIPE_MONTHLY' | 'CGA_STRIPE_YEARLY') => {
    setIsLoading(true);
    setError('');

    try {
      const { data: { session } } = await supabase.auth.getSession();
      if (!session) throw new Error('Not logged in');

      const res = await fetch('https://cdnbjnapvlbmarhuflsv.supabase.co/functions/v1/create-checkout-session', {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${session.access_token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ price_key: priceKey })
      });

      if (!res.ok) throw new Error('Failed to create checkout session');
      const data = await res.json();

      if (data?.url) {
        window.location.href = data.url;
      } else {
        throw new Error('No URL returned from checkout session');
      }

    } catch (err: any) {
      console.error('Checkout error:', err);
      setError(err.message || 'Something went wrong. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-b from-white to-blue-50 flex flex-col items-center justify-center px-6 py-12">
      <div className="max-w-2xl w-full bg-white rounded-xl shadow-lg p-8 space-y-6 text-center">
        <h1 className="text-4xl font-bold text-[#004060]">Your Trial Has Ended</h1>

        <p className="text-lg text-gray-700">
          Your 10-day free trial is complete — we hope it helped you grow.
        </p>

        <p className="text-md text-gray-700 mt-2">
          To keep journaling, building your Gold File, and making consistent progress,
          subscribe below and continue your growth.
        </p>

        <div className="space-y-4 mt-6">
          <Button
            onClick={() => handleCheckout('CGA_STRIPE_MONTHLY')}
            className="w-full"
            disabled={isLoading}
          >
            {isLoading ? 'Redirecting…' : '$10/month – Stay on Track'}
          </Button>

          <Button
            onClick={() => handleCheckout('CGA_STRIPE_YEARLY')}
            className="w-full"
            variant="outline"
            disabled={isLoading}
          >
            {isLoading ? 'Redirecting…' : '$99/year – Save 17%'}
          </Button>

          {error && <p className="text-red-600 text-sm mt-2">{error}</p>}
        </div>

        <div className="mt-8 text-left">
          <h2 className="text-lg font-semibold text-[#004060] mb-2">Prefer not to continue?</h2>
          <p className="text-sm text-gray-600 mb-4">
            No problem. You can download your Gold File and take your insights with you.
          </p>
          <GoldFileDownloadButton />
        </div>
      </div>
    </div>
  );
}
